import React from 'react';
import cx from 'classnames';
import { t, props } from 'tcomb-react';

@props({
  children: t.Any,
  type: t.maybe(t.Str)
})
export default class Alert extends React.Component {

  getContainerClasses() {
    const type = this.props.type;
    return cx({
      'alert': true,
      'success': type === 'success',
      'error': type === 'error',
      'warning': type === 'warning',
      'danger': type === 'danger',
      'info': type === 'info'
    });
  }

  render() {
    return (
      <div className={this.getContainerClasses()}>
        { this.props.children }
      </div>
    );
  }
}




/** WEBPACK FOOTER **
 ** C:/repository/madai/v6/client/lib/web/components/Alert.js
 **/